import React, { useContext, useState } from "react";
import { CommandBarButton } from "sprint-common-web";

import { AuthorizationWrapper } from "../../../core/security/AuthorizationWrapper";
import { SprintAccessRight } from "../../../core/security/SprintAccessRight";
import { OrderListingContext } from "../listing/context/OrderListingContext";
import { DeleteMultipleOrdersDialog, mapToRemoveOrderItem } from "./DeleteMultipleOrdersDialog";

export const DeleteMultipleOrdersButton: React.VFC = () => {
    const { selectedItems } = useContext(OrderListingContext);

    const [isOpen, setIsOpen] = useState<boolean>(false);

    const open = () => {
        setIsOpen(true);
    };

    const close = () => {
        setIsOpen(false);
    };

    const handleRemovingComplete = () => {
        close();
    };

    return (
        <AuthorizationWrapper accessRights={[SprintAccessRight.OrdAdmin]}>
            <CommandBarButton text="Delete" icon="Delete" disabled={!selectedItems.length} onClick={open} />
            {isOpen && (
                <DeleteMultipleOrdersDialog
                    key={String(isOpen)}
                    selectedItems={selectedItems.map((item) => mapToRemoveOrderItem(item))}
                    onRemovingComplete={handleRemovingComplete}
                />
            )}
        </AuthorizationWrapper>
    );
};
